import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, logEvent as firebaseLogEvent, isSupported } from 'firebase/analytics';

// TODO: Replace with your Firebase project configuration
// Get these values from Firebase Console > Project Settings > General > Your apps > Web app
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "YOUR_PROJECT_ID.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "YOUR_PROJECT_ID",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "YOUR_PROJECT_ID.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "YOUR_MESSAGING_SENDER_ID",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "YOUR_APP_ID",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "YOUR_MEASUREMENT_ID"
};

console.log('🔵 Firebase Config:', {
  apiKey: firebaseConfig.apiKey ? '✅ Set' : '❌ Not set',
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  storageBucket: firebaseConfig.storageBucket,
  messagingSenderId: firebaseConfig.messagingSenderId ? '✅ Set' : '❌ Not set',
  appId: firebaseConfig.appId ? '✅ Set' : '❌ Not set',
});

// Check if using placeholder values
if (firebaseConfig.projectId === 'YOUR_PROJECT_ID') {
  console.error('❌ Firebase not configured! Using placeholder values.');
  console.error('❌ Create a .env file with your Firebase credentials.');
  console.error('❌ See FIREBASE_SETUP.md for instructions.');
}

// Initialize Firebase
console.log('🔵 Initializing Firebase...');
const app = initializeApp(firebaseConfig);
console.log('✅ Firebase app initialized');

// Initialize Firestore
console.log('🔵 Initializing Firestore...');
export const db = getFirestore(app);
console.log('✅ Firestore initialized');

// Initialize Analytics
let analytics = null;
isSupported().then((supported) => {
  if (supported) {
    console.log('🔵 Initializing Firebase Analytics...');
    analytics = getAnalytics(app);
    console.log('✅ Firebase Analytics initialized');
  } else {
    console.log('⚠️ Firebase Analytics not supported in this environment');
  }
}).catch((error) => {
  console.error('❌ Error checking Analytics support:', error);
});

// Helper function to log analytics events safely
export const logEvent = (eventName, eventParams) => {
  if (analytics) {
    firebaseLogEvent(analytics, eventName, eventParams);
    console.log('📊 Analytics event logged:', eventName, eventParams);
  }
};

export { analytics };
